// Approved second-reach copy shared by the invitation and post-trial reference.
export const FIVE_DAY_INTRO = "Keep your morning caffeinated beverage. Vitura is for the moment you’d grab another — so you stay locked in all day without paying for it at bedtime.";

export const FIVE_DAY_TIMING = [
  { id: "training", label: "If you train", title: "After your workout.", copy: "Keep your usual pre-workout or energy drink. Take Vitura after to recover and perform for the workday." },
  { id: "coffee", label: "If you drink coffee", title: "Instead of your second cup.", copy: "Keep your first cup. Make Vitura the second — locked in all afternoon, without wrecking your sleep." },
];

export const FIVE_DAY_SERVING = {
  title: "Best chilled. Shake well. Shoot it.",
  copy: "Bright first sip, botanical finish — that’s the lion’s mane, ashwagandha, holy basil and saffron doing their jobs.",
};

export const FIVE_DAY_REMINDERS = [
  { icon: "five", copy: "Five days straight — one shot is a taste, five days is a signal." },
  { icon: "pattern", copy: "On a WHOOP, Oura or Garmin? Monitor your recovery during the week." },
];

export const FIVE_DAY_EXPECTATIONS = [
  ["1", "clean lift within 30 minutes. No jitter, no 3pm cliff."],
  ["3", "steadier mood, cleaner focus, calmer evenings."],
  ["5", "energy, focus and mood feel reliable — and this is just the beginning. The adaptogens and functional mushrooms keep compounding over four-plus weeks."],
];